import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertifyService } from '@services/alertify.service';
import { AuthService } from '@services/auth.service';
import { UserDto } from '@models/user-dto';
import { UserClassesService } from '@services/user-classes.service';
import { UserCourseDto, createUserCourseDto } from '@models/user-course-dto';
import { TranslateService } from '@ngx-translate/core';
import { Bootstrap_Modal_Service } from '@services/bootstrap-modal.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  model: any = {};
  loginForm: FormGroup;
  processing: boolean;
  showPassword: boolean = false;

  constructor(
    private fb: FormBuilder, 
    private router: Router,
    public authService: AuthService, 
    private alertify: AlertifyService,
    private userClassesService: UserClassesService,
    private translate: TranslateService,
    private bootstrap_modal: Bootstrap_Modal_Service
  ) { }
    
  ngOnInit() {
    this.createLoginForm();

    this.processing = false; // Initialize as false, not true
    if (this.authService.loggedIn()) {
      this.router.navigate(['/home']); 
    }

  }

  getUrl() {
    return "url('assets/sky8.jpg')";
  }
  createLoginForm() {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', [Validators.required]]
    });
  }

  login() {
    if (this.loginForm.invalid) {
      return;
    }

    this.processing = true; // Start processing
    this.model = Object.assign({}, this.loginForm.value);

    this.authService.login(this.model).subscribe(next => {

      this.translate.get(["ALERTIFY.LOGGED_IN", "BOOTSTRAP.MODAL.SUCCESS"]).subscribe((text: string) => {
        this.alertify.success(text['ALERTIFY.LOGGED_IN'])

        this.bootstrap_modal.open({
          modal_header_html: text['BOOTSTRAP.MODAL.SUCCESS'],
          modal_body_html: text['ALERTIFY.LOGGED_IN'],
          modal_color_variant: "success"
        })
      })

      // tslint:disable-next-line:no-shadowed-variable
    }, error => {
      console.error(error)
      this.processing = false; // Stop processing on error

      this.translate.get(['ALERTIFY.INCORRECT_CREDENTIALS', 'BOOTSTRAP.MODAL.ERROR']).subscribe((translations: Record<string, string>) => {
        const incorrectCredentialsMessage = translations['ALERTIFY.INCORRECT_CREDENTIALS'];
        const modalErrorTitle = translations['BOOTSTRAP.MODAL.ERROR'];
        this.alertify.error(incorrectCredentialsMessage)

        this.bootstrap_modal.open({
          modal_header_html: modalErrorTitle,
          modal_body_html: `${incorrectCredentialsMessage}`,

          modal_color_variant: "danger"
        })

      })

    }, () => {

        // check percentaje
        // check if student finishes all classes
        const userCourseDto = createUserCourseDto({
          userId: this.authService.returnCurrentUser().id,
          courseId: this.authService.returnCourseId(),
          isCourseComplete: 'true'  //true, just for not generate the certificate of complition, when the value is true it does not generate the certificate. 
        });

        this.userClassesService.CheckAllClassesComplete(userCourseDto).subscribe((courseCompleted: number) => {
          // set percentage
          let percentageWatched = courseCompleted * 100 / 30;
          localStorage.setItem('percentage', percentageWatched.toString());
          if (courseCompleted == 30) {
            this.authService.setCourseCompleted();
          }
        }
        );


      const userDto: UserDto = JSON.parse(localStorage.getItem('user'));

      //  Object.assign(user, userDto);
      if (!this.authService.currentUser['mustChangePassword']) {
        // everithign OK  -> should go to Menu 
        this.processing = false; // Stop processing before navigation
        this.router.navigate(['/app/welcome']); 
      } else {

        this.translate.get(["ALERTIFY.USER_MUST_CHANGE_PASSWORD", "BOOTSTRAP.MODAL.ERROR"]).subscribe((translations: Record<string, string>) => {
          const modalErrorTitle = translations['BOOTSTRAP.MODAL.ERROR'];
          const userMustChangePasswordMessage = translations['ALERTIFY.USER_MUST_CHANGE_PASSWORD'];
          this.alertify.error(userMustChangePasswordMessage)

          this.bootstrap_modal.open({
            modal_header_html: modalErrorTitle,
            modal_body_html: userMustChangePasswordMessage,
            modal_color_variant: "danger"
          })

        });

        this.processing = false; // Stop processing before navigation
        this.router.navigate(['/app/change-password', this.authService.returnCurrentUser().id]);
      }
    });
  }

  register() {
    this.router.navigate(['/register']);
  }

}
